import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from "../views/Login";
import Home from "../views/Home";
import Course from "../views/Course";
import Lesson from "../views/Lesson";

import Login2 from "../views/Login2";
import V404 from "../views/404"
import NoCourse from "../views/NoCourse";
import LoginError from "../views/LoginError";
import Footer from "../components/Footer";
import Study from "../views/Study";
import Mine from "../views/Mine";
import Header from "../components/Header";
import Register from "../views/Register";
import ForgetPwd from '../views/ForgetPwd';
import MsgCodeLogin from '../views/MsgCodeLogin';
import ResetPwd from '../views/ResetPwd';
import Card from '../test/Card';
import NoOrder from '../components/NoOrder';
import Refresh from '../components/Refresh';
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/',
      name:'Login',
      component: Login,
      meta: {
        keepAlive: true // 需要缓存
      }
    },
    {
      path: '/home',
      name:'Home',
      component: Home,
      meta: {
        keepAlive: true // 需要缓存
      }
    },
    {
      path: '/course',
      name:'Course',
      component: Course,
      meta: {
        keepAlive: false // 需要缓存
      }
    },
    {
      path: '/lesson',
      name:'Lesson',
      component: Lesson,
      meta: {
        keepAlive: false // 需要缓存
      }
    },
    {
      path:'/login2',
      name:'Login2',
      component:Login2
    },
    {
      path:'/404',
      name:'V404',
      component:V404
    },
    {
      path:'/noCourse',
      name:'NoCourse',
      component:NoCourse
    },
    {
      path:'/loginError',
      name:'LoginError',
      component:LoginError
    },
    {
      path:'/footer',
      name:'Footer',
      component:Footer
    },
    {
      path:'/study',
      name:'Study',
      component:Study
    },
    {
      path:'/mine',
      name:'Mine',
      component:Mine
    },
    {
      path:'/header',
      name:'Header',
      component:Header
    },
    {
      path:'/register',
      name:'Register',
      component:Register
    },
    {
      path:'/forgetPwd',
      name:'ForgetPwd',
      component:ForgetPwd
    },
    {
      path:'/msgCodeLogin',
      name:'MsgCodeLogin',
      component:MsgCodeLogin
    },
    {
      path:'/resetPwd',
      name:'ResetPwd',
      component:ResetPwd
    },
    {
      path:'/card',
      name:'Card',
      component:Card
    },
    {
      path:'/noOrder',
      name:'NoOrder',
      component:NoOrder
    },
    {
      path:'/refresh',
      name:'Refresh',
      component:Refresh
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js